import styled from 'styled-components';
import { fadeInAndUp } from '../base/keyframes/fades';
import { sequencedAnimationDelay } from '../base/utils';
import { Column } from '../base';

export const AnimatedColumn = styled(Column)`
	opacity: 0;
	animation: ${fadeInAndUp} 300ms;
	animation-fill-mode: forwards;
	${sequencedAnimationDelay(30, 0.03)};
`;
